import logSystemUtil from '../../../logs/redux/actions/log'
import addInstance from './add-instance'
import getClassNameReduxUtil from '../get-class-name'
import addInstanceToDomainListsReduxUtil from '../add-instance-to-domain-lists'
import getInstanceReduxUtil from '../get-instance'

/**
 * Adds the instance to the given path.
 * @param   {Object}  params
 *          {Object} state
 *          {Instance[]} instance
 *          {string} [domainListPath]
 *          {Object} [options]
 * @returns {Object}
 */
function addReduxUtil (params) {
  let {
    state,
    instance,
    existingInstance,
    domainListPath,
    options
  } = params

  if (!instance) {
    return state
  }

  logSystemUtil('addReduxUtil').debug(`className=${getClassNameReduxUtil(instance)}`)

  // Add the instance
  state = addInstance({
    state,
    instance,
    existingInstance
  })

  // Add the instance to the DomainList
  instance = getInstanceReduxUtil(state, instance)
  state = addInstanceToDomainListsReduxUtil({
    state,
    instance,
    domainListPath,
    existingInstance,
    options
  })

  return state
}

export default addReduxUtil
